<template>
  <div class="payment-method-symbol" :class="[size, { outlined: isOutlined }]">
    <img
      v-if="isAeropay"
      :alt="$t('paymentmethod.aeropay.alt')"
      src="~/assets/img/payment/aeropay-small.svg"
    />

    <LcIcon v-else-if="isBank" name="bank" v-bind="{ size }" />

    <NuxtImg
      v-else-if="isPaymentIcon(variant)"
      :alt="variant.title"
      class="flex items-center justify-center"
      :height="variant.icon.height"
      :src="variant.icon.url"
      :width="variant.icon.width"
    />

    <PaymentMethodSymbolFallback v-else v-bind="{ size }" />
  </div>
</template>

<script lang="ts" setup>
import type { PaymentIcon } from '../composables/paymentIcons'

export type PaymentMethodSymbolProps = {
  outlined?: boolean
  size?: 'medium' | 'small'
  variant?: 'Aeropay' | 'Bank' | PaymentIcon
}

const { outlined = true, size = 'medium', variant } = defineProps<PaymentMethodSymbolProps>()

const isAeropay = computed(() => variant === 'Aeropay')

const isBank = computed(() => variant === 'Bank')

const isOutlined = computed(
  () => outlined && (!isPaymentIcon(variant) || !variant.isLogoComplianceStrict),
)

const isPaymentIcon = (_variant: PaymentMethodSymbolProps['variant']): _variant is PaymentIcon =>
  typeof _variant === 'object' && (_variant as PaymentIcon).icon !== undefined
</script>

<style lang="scss" scoped>
.payment-method-symbol {
  display: flex;
  justify-content: center;
  align-items: center;

  &.medium {
    width: 3rem;
    height: 1.875rem;
  }

  &.small {
    width: 2.5rem;
    height: 1.5rem;
  }

  &.outlined {
    padding: token('size/space/gap/050') token('size/space/gap/025');
    border: 0.063rem solid #afd9f9;
    border-radius: token('size/radius/s');
    background: linear-gradient(180deg, rgb(238, 249, 255, 40%) 0%, rgb(255, 255, 255, 40%) 100%);
  }
}
</style>
